module.exports = {"ticketView":"Ticket View","announcementDetail":"Announcement Details"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en-US/mixins.json
// module id = JCWi
// module chunks = 1